import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeDe from '@angular/common/locales/de';
import localeFr from '@angular/common/locales/fr';
import localeIt from '@angular/common/locales/it';

registerLocaleData(localeEn);
registerLocaleData(localeDe);
registerLocaleData(localeFr);
registerLocaleData(localeIt);

const CHUNK_RELOAD_KEY = 'ss:chunk-reload';

function isChunkLoadError(reason: unknown): boolean {
  const message = reason instanceof Error ? `${reason.name} ${reason.message}` : String(reason ?? '');
  return /ChunkLoadError|Loading chunk [\d]+ failed|dynamically imported module|Importing a module script failed/i.test(message);
}

function reloadOnChunkError(reason: unknown): void {
  if (!isChunkLoadError(reason)) return;
  if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) return;
  sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
  location.reload();
}

window.addEventListener('error', (event) => reloadOnChunkError(event.error ?? event.message));
window.addEventListener('unhandledrejection', (event) => reloadOnChunkError(event.reason));

bootstrapApplication(App, appConfig)
  .then(() => sessionStorage.removeItem(CHUNK_RELOAD_KEY))
  .catch((err) => {
    reloadOnChunkError(err);
    console.error(err);
  });
